export default "__VITE_ASSET__CZeek3Ds__"